var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isHeader)?_c('th',{on:{"click":function($event){return _vm.onColumnHeaderClicked(_vm.rowField, $event)}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.title)}})]):_c('td',[_vm._v(" "+_vm._s(_vm.formatEmptyString(_vm.formatter(_vm.getMethodByPath(_vm.rowData, _vm.rowField.label))))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }